import { CSSTransition, TransitionGroup } from 'react-transition-group';
import cn from 'classnames';

import Coins from 'components/icons/Coins';
import CloseX from 'components/icons/navigation/CloseX';

import style from 'styles/components/messageCenter/Reward';

const Reward = ({ onUpdateMessage, heading, subheading, shown, id }) => {
  const handleDismissRewardMessage = () => {
    onUpdateMessage({ id, read: true });
  };
  return (
    <TransitionGroup>
      {shown && (
        <CSSTransition
          timeout={400}
          classNames={{
            enter: 'fadeInOut-enter scaleHeight-enter',
            enterActive: 'fadeInOut-enter-active scaleHeight-enter-active',
            exit: 'fadeInOut-exit scaleHeight-exit',
            exitActive: 'fadeInOut-exit-active scaleHeight-exit-active',
          }}
        >
          <aside
            className={cn(
              'p-2 bg-white-100 mt-6 mb-8 mx-auto flex items-center relative',
              style.container
            )}
          >
            <Coins className="w-16 ml-4 mr-0 bp1:mr-4" />

            <div className="p-4 flex">
              <div className="flex flex-col justify-center">
                <h2 className="text-charcoal-90 h7">Rewards</h2>
                <h3 className="text-green-100 h4 font-semibold my-1">{heading}</h3>
                {subheading ? <p className="text text-sm font-normal">{subheading}</p> : null}
              </div>
              <button
                onClick={handleDismissRewardMessage}
                className="absolute top-0 right-0 mt-4 mr-4"
              >
                <CloseX className="w-6 h-6" />
              </button>
            </div>
          </aside>
        </CSSTransition>
      )}
    </TransitionGroup>
  );
};

Reward.propTypes = {
  subheading: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  onUpdateMessage: PropTypes.func.isRequired,
  shown: PropTypes.bool.isRequired,
};

Reward.defaultProps = {
  shown: true,
};

export default Reward;
